import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SupportListDetailComponent } from '@app/features/support/components/support-list-detail/support-list-detail.component';
import { SupportListTableComponent } from '@app/features/support/components/support-list-table/support-list-table.component';
import { ServiceChangeComponent } from '@app/features/support/pages/service-change/service-change.component';
import { SupportTicketListComponent } from '@app/features/support/pages/support-ticket-list/support-ticket-list.component';
import { SupportTicketComponent } from '@app/features/support/pages/support-ticket/support-ticket.component';
import { SupportRoutingModule } from '@app/features/support/support-routing.module';
import { SupportComponent } from '@app/features/support/support.component';
import { SharedModule } from '@app/shared/shared.module';
import { CancelCaseDialogComponent } from './components/cancel-case-dialog/cancel-case-dialog.component';
import { CaseDetailDialogComponent } from './components/case-detail-dialog/case-detail-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SupportRoutingModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    SupportComponent,
    SupportTicketComponent,
    SupportTicketListComponent,
    SupportListTableComponent,
    SupportListDetailComponent,
    ServiceChangeComponent,
    CaseDetailDialogComponent,
    CancelCaseDialogComponent,
  ],
})
export class SupportModule {}
